// extracted by mini-css-extract-plugin
export default {"host":"AddReport_host__-nvBA"};